import { render, staticRenderFns } from "./Slow.vue?vue&type=template&id=4b1c902c&scoped=true&"
import script from "./Slow.vue?vue&type=script&lang=ts&"
export * from "./Slow.vue?vue&type=script&lang=ts&"
import style0 from "./Slow.vue?vue&type=style&index=0&id=4b1c902c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1c902c",
  null
  
)

export default component.exports